import { useMatchMedia } from 'hooks/useMatchMedia';
import { useOrientation } from 'hooks/useOrientation';
import { useFullscreen } from 'hooks/useFullscreen';

/** Mobile + tablet widths where immersive landscape layout applies. */
export const TABLE_COMPACT_MAX_WIDTH = 1024;

export type TableLayoutMode = 'desktop' | 'mobile-portrait' | 'mobile-landscape';

export function useTableLayoutMode() {
  const isCompact = useMatchMedia(`(max-width: ${TABLE_COMPACT_MAX_WIDTH}px)`);
  const orientation = useOrientation();
  const isLandscape = orientation === 'landscape';
  const fullscreen = useFullscreen();

  const mode: TableLayoutMode = !isCompact
    ? 'desktop'
    : isLandscape
      ? 'mobile-landscape'
      : 'mobile-portrait';

  return {
    mode,
    isCompact,
    isLandscape,
    orientation,
    ...fullscreen,
  };
}
